export default "__VITE_ASSET__OJjja$dW__"